export const IS_DEVELOPMENT_ENVIRONMENT = process.env.NODE_ENV === "development";
export const LOCAL_STORAGE_NAME_SPACE = "VON_LUCK_ONLINE_SHOP";
export const SERVER_ADDRESS: string = process.env.REACT_APP_SERVER_ADDRESS!;
export const PRODUCTS_LIST_ELEMENT_ID = "products-list-element";
export const SUBMITTING_ERROR_ELEMENT_ID = "submitting-error-element";
